(function () {
  var PRICE_SELECTORS = [
    '.product-single__meta .product-block--price [class*="priceClr"]',
    '.product-single__meta .product-block--price .price-new',
    '.product-single__meta .product-block--price em',
    '.product-single__meta .product-block--price .price',
    '.product-single__meta .price-item--sale',
    '.product-single__meta .product-single__price'
  ];

  var BUTTON_SELECTORS = [
    '.product-single__meta button[name="add"]',
    '.product-form button[name="add"]',
    '.product-details button[name="add"]'
  ];

  var GALLERY_SELECTORS = [
    '.product-single__photos-wrapper',
    '.product-single__photos',
    '.product__media-wrapper',
    '.product-single__media-group'
  ];

  function q(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function injectSaleBadge() {
    var pct = window.pdpSalePct;
    if (!pct || pct <= 0) return;
    var gallery = q(GALLERY_SELECTORS);
    if (!gallery) return;
    if (gallery.querySelector('.pdp-m-sale-tag')) return;

    var tag = document.createElement('div');
    tag.className = 'pdp-m-sale-tag';
    tag.textContent = Math.round(pct) + (window.pdpSaleLabel || '% off');
    var cs = window.getComputedStyle(gallery);
    if (cs.position === 'static') gallery.style.position = 'relative';
    gallery.prepend(tag);
  }

  function getPriceText() {
    var el = q(PRICE_SELECTORS);
    return el ? el.textContent.trim().replace(/\s+/g, ' ') : '';
  }

  function updateAtcButton() {
    var btn = q(BUTTON_SELECTORS);
    if (!btn) return;
    var price = getPriceText();
    if (!price) return;
    var label = window.pdpAtcLabel || 'Add to bag';
    if (!btn.hasAttribute('data-atc-base')) {
      btn.setAttribute('data-atc-base', btn.textContent.trim() || label);
    }
    btn.textContent = label + ' — ' + price;
  }

  function observePriceChanges() {
    var priceEl = q(PRICE_SELECTORS);
    if (!priceEl || !window.MutationObserver) return;
    var parent = priceEl.parentNode || priceEl;
    new MutationObserver(function () {
      updateAtcButton();
    }).observe(parent, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    injectSaleBadge();
    updateAtcButton();
    observePriceChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
